import type { UseToastOptions } from "@chakra-ui/react"
import { useToast as useChakraToast } from "@chakra-ui/react"

/**
 * @deprecated Import `useToast` from `@chakra-ui/react` directly and modify ChakraProvider `toastOptions` to change default options.
 *
 */
export function useToast() {
  const toast = useChakraToast()
  const handleToast = (props: UseToastOptions) => {
    toast({
      position: "bottom-left",
      isClosable: true,
      duration: 10000,
      ...props,
    })
  }
  return handleToast
}
